import currencyFormatter from 'currency-formatter';
const PricingTableFooter = ({ totalLHSAmt, totalRHSAmt,details }) => (


    
    <tfoot className="smartTable-fixedBottom mt-1">
        <tr>
            <td><h6 className="font-weight-bold mt-2 pl-1">Total</h6></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td> </td>
            
            <td>
                <h6 className="lhsText font-weight-bold mt-2 text-right">{currencyFormatter.format(totalLHSAmt, { code: `${details.currency}` })}</h6>
            </td>
           
            <td>
               
            </td>
            <td></td>
            <td>
                <h6 className="rhsText font-weight-bold mt-2 text-right">
                {currencyFormatter.format(totalRHSAmt, { code: `${details.currency}` })}
                </h6>
            </td>
            <td></td>
            <td></td>
          
        </tr>
    </tfoot>
);
export default PricingTableFooter